import { styled, css } from 'styled-components';
import { colors } from '../../../abstracts/colors';
import { getFontSize, getFontWeight } from '../../../abstracts/typography';
import { createTransition, dontForwardProps } from '../../../util';
const successState = css(["color:", ";"], colors.successDeeper);
const warnState = css(["color:", ";"], colors.black);
const errorState = css(["color:", ";"], colors.errorDeep);
const defaultState = css(["color:", ";"], colors.neutralDeeper);
const helperTextStateToCss = {
  success: successState,
  warn: warnState,
  error: errorState,
  default: defaultState
};
export const TextFieldHelperText = styled.div.withConfig(dontForwardProps()).withConfig({
  displayName: "TextFieldHelperText",
  componentId: "asurion-ui-react__sc-1paoz1t-0"
})(["font-size:", ";line-height:130%;-moz-osx-font-smoothing:grayscale;font-weight:", ";padding:0.25rem 0.75rem;background-color:transparent;", ";", ";"], getFontSize(1), getFontWeight('base'), ({
  fieldStatus
}) => helperTextStateToCss[fieldStatus], createTransition({
  properties: ['color']
}));